import { Message, Topic } from "@visioni/a3s-messages";
import z from "zod/v4";

const Coordinate = z.object({
  lat: z.number().min(-90).max(90),
  lng: z.number().min(-180).max(180),
});

export const LineCrossScenarioStatus = z.object({
  scenarioUuid: z.string(),
  scenarioName: z.string(),
  stale: z.boolean().optional(),
  /**
   * True when the operator has excluded this scenario from the roadsense
   * report. API-only field: operator-set via `PUT /scenarios/{uuid}` and
   * echoed in the list response. The edge daemon never publishes it.
   */
  excluded: z.boolean().optional(),
  coordinate: Coordinate.optional(),
  /**
   * Compass bearing in degrees clockwise from true north (0 = N, 90 = E,
   * 180 = S, 270 = W). Range is `[0, 360)`.
   *
   * Provenance: operator-set via `PUT /scenarios/{uuid}` and then included
   * in the API list response — this schema is reused as the row codec for
   * both the camera→cloud MQTT event and the API. The edge daemon does
   * NOT publish a bearing; only `scenarioUuid` and `scenarioName` are
   * emitted from the camera (see `edge/publish-scenario-status.ts`).
   */
  direction: z.number().min(0).lt(360).optional(),
  friendlyName: z.string().optional(),
  configUpdatedAt: z.iso.datetime().optional(),
  configUpdatedBy: z.string().optional(),
});
export type LineCrossScenarioStatus = z.infer<typeof LineCrossScenarioStatus>;

export const LineCrossScenarioStatusEvent = Message({
  typ: "LineCrossScenarioStatusEvent",
  ver: "1",
  dat: z.object({ scenarios: z.array(LineCrossScenarioStatus) }),
});
export type LineCrossScenarioStatusEvent = z.infer<typeof LineCrossScenarioStatusEvent>;

/** `G2/{tenant}/{site}/{asset}/{camera}/traffic-flow-status/events` */
export const LineCrossScenarioStatusTopic = Topic.camera("traffic-flow-status", "events");
